import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import logoImg from "../../assets/logo.png";

export function Header() {
  return (
    <Navbar bg='dark' variant='dark' collapseOnSelect expand='lg'>
      <Container>
        <Navbar.Brand href='https://codev.utahcounty.gov/fire-marshal'>
          <img alt='' src={logoImg} width='75' className='d-inline-block align-center' />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls='responsive-navbar-nav' />
        <Navbar.Collapse id='responsive-navbar-nav'>
          <Nav className=' me-auto'>
            <Nav.Link href='https://www.utahcounty.gov/'>
              <span className='navitem'>County Home</span>
            </Nav.Link>

            <Nav.Link href='https://www.utahcounty.gov/Dept/FireMarshal/Burn_q.asp'>
              <span className='navitem'>Burn Notice Form</span>
            </Nav.Link>

            <Nav.Link href='http://youtu.be/-wb7N1PW0ak'>
              <span className='navitem'>Living With Fire Video</span>
            </Nav.Link>

            <NavDropdown title={<span className='navitem'>Links</span>} id='collasible-nav-dropdown'>
              <NavDropdown.Item href='https://www.utahcounty.gov/Dept/FireMarshal/about.asp'>About Us</NavDropdown.Item>
              <NavDropdown.Item href='https://www.utahcounty.gov/Dept/FireMarshal/gallery.asp'>
                Photo Gallery
              </NavDropdown.Item>
              <NavDropdown.Item href='https://www.utahcounty.gov/Dept/FireMarshal/staff.asp'>
                Our Staff
              </NavDropdown.Item>
              <NavDropdown.Item href='https://www.utahcounty.gov/LocalInfo/Cities.asp'>
                Utah County Cities
              </NavDropdown.Item>
              <NavDropdown.Item href='https://www.weather.gov/slc/ClearingIndex#tab-3'>
                Airshed 8/Clearing Index
              </NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title={<span className='navitem'>Permits</span>} id='collasible-nav-dropdown'>
              <NavDropdown.Item to='/' as={Link}>
                Burn Permit
              </NavDropdown.Item>
              <NavDropdown.Item to='/construction-permit' as={Link}>
                LPG Construction Permit
              </NavDropdown.Item>
              <NavDropdown.Item to='/fuel-tank-permit' as={Link}>
                Above Ground Fuel Tank Permit
              </NavDropdown.Item>
              <NavDropdown.Item to='/pyrotechnics' as={Link}>
                Pyrotechnics Permit
              </NavDropdown.Item>
              <NavDropdown.Item to='/hazmat-permit' as={Link}>
                Hazmat Permit
              </NavDropdown.Item>
              <NavDropdown.Item to='/blasting-permit' as={Link}>
                Blasting Permit
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
